import React, { useContext } from "react"
import ParticipantTracks from "~/components/twilio/ParticipantTracks"
import MainParticipantInfo from "~/components/twilio/MainParticipantInfo"
import { VideoContext } from "~/components/twilio/VideoProvider"
import { ParticipantsContext } from "~/components/twilio/ParticipantsProvider"
import { VideoQuality } from "~/components/twilio/VideoProvider"
export default function MainParticipant() {
  const { client } = useContext(VideoContext)
  const { participants, selectParticipant, dominantSpeakerId } = useContext(ParticipantsContext)
  const currentUser = client?.getCurrentUserInfo()

  // QuanHH: update as soon as the selected participant changes
  let userInfo = currentUser
  if (participants?.length <= 1) {
    userInfo = currentUser
  } else if (selectParticipant?.userId) {
    userInfo = participants.find((participant) => participant.userId === selectParticipant.userId)
  } else if (dominantSpeakerId) {
    userInfo = participants.find((participant) => participant.userId === dominantSpeakerId)
  } else {
    userInfo = participants[participants.length - 1]
  }
  return (
    <MainParticipantInfo user={userInfo}>
      {/* // HungHV: care of video or audio display */}
      <ParticipantTracks userInfo={userInfo} quality={VideoQuality.Video_720P} isMain={true} />
    </MainParticipantInfo>
  )
}
